<script>
export default {
  name: 'BaseNavigationLoader'
}
</script>

<template>
  <v-overlay>
    <v-progress-circular
      :size="100"
      :width="5"
      indeterminate
    />
  </v-overlay>
</template>
